import { render, staticRenderFns } from "./ProjectsDocumentsFilteredList.vue?vue&type=template&id=0af204bc&scoped=true"
import script from "./ProjectsDocumentsFilteredList.vue?vue&type=script&lang=ts"
export * from "./ProjectsDocumentsFilteredList.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsDocumentsFilteredList.vue?vue&type=style&index=0&id=0af204bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af204bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0af204bc')) {
      api.createRecord('0af204bc', component.options)
    } else {
      api.reload('0af204bc', component.options)
    }
    module.hot.accept("./ProjectsDocumentsFilteredList.vue?vue&type=template&id=0af204bc&scoped=true", function () {
      api.rerender('0af204bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/ProjectsDocumentsFilteredList.vue"
export default component.exports